import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconsModule, icoTickCircleDuo, icoTimeDuo } from '../icons';
import { TooltipModule } from '../tooltip';
import { StatusTagComponent } from './status-tag/status-tag.component';

@NgModule({
  declarations: [StatusTagComponent],
  imports: [CommonModule, TooltipModule, IconsModule.withIcons(icoTickCircleDuo, icoTimeDuo)],
  exports: [StatusTagComponent]
})
export class StatusTagModule {}
